import { ReactNode } from 'react';

import { Container } from '@sorare/core/src/atoms/layout/Container';
import { EnsureTopVisibleOnMount } from '@sorare/core/src/routing/EnsureTopVisibleOnMount';
import { breakpoints } from '@sorare/core/src/style/mediaQuery';

import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

import { Form } from 'components/Form';

export const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <AppLayout>
      <Container maxWidth={breakpoints.mediumDesktop}>
        <EnsureTopVisibleOnMount behavior="auto">
          {children}
          <Form />
        </EnsureTopVisibleOnMount>
      </Container>
    </AppLayout>
  );
};
